;(function () {
	const copyrightContainer = document.getElementById("copyright");
	if(copyrightContainer != null) {
		copyrightContainer.innerHTML = "-"+new Date().getFullYear();
	}
})();

